import { render, staticRenderFns } from "./SelectCourseCluster.vue?vue&type=template&id=79ec2c63"
import script from "./SelectCourseCluster.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectCourseCluster.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports